export default {
  improvement_plans_detail: {
    create_form: {
      cautions_title: '@:settings.cautions_title',
      cautions_content: '・Informasi yang harus diisi dalam rencana perbaikan ditunjukkan pada {toCompanyName}.\n・Lampiran ditampilkan di {toCompanyName}, dan hanya nama file yang akan ditampilkan.',
    },
    chat: {
      card_title: 'Pesan',
      input_area_description: 'Anda dapat mengirim pesan ke {toCompanyName} mengenai rencana perbaikan',
      send_confirm: {
        modal_title: 'Periksa pesan yang akan dikirim',
        confirm_text: 'Anda yakin ingin mengirim pesan ini?',
        confirm_text_near_by_check_box: 'Pesan telah diperiksa',
        send_button_label: '@:upload_common.send',
      },
      send_complete: {
        // toast_text:
      },
      delete_confirm: {
        modal_title: 'Hapus pesan ini',
        confirm_text: 'Anda yakin ingin menghapus pesan ini?',
        delete_button_label: '@:settings.button.do_delete',
      },
      log: {
        title: 'Kirim riwayat',
        send_status: {
          success: 'Terkirim',
          failure: 'Gagal mengirim',
        },
      },
    },
  },
}
